import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";

export const VideoThumbnail = ({ src, alt = "video thumbnail", width = "100%", height = "100%" }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!src) {
      setFailed(true);
      setLoaded(true);
    } else {
      setLoaded(false);
      setFailed(false);
    }
  }, [src]);

  return (
    <Box
      sx={{
        position: "relative",
        width,
        height,
        overflow: "hidden",
        borderRadius: "5px",
        border: "1px solid #E0E0E0",
        backgroundColor: "#F4F4F4"
      }}>
      {!loaded && <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />}

      {!failed ? (
        <Box
          component="img"
          alt={alt}
          src={src}
          onLoad={() => setLoaded(true)}
          onError={() => {
            setFailed(true);
            setLoaded(true);
          }}
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: loaded ? 1 : 0,
            transition: "opacity 0.2s ease"
          }}
        />
      ) : (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.disabled",
            bgcolor: "#F4F4F4"
          }}>
          <ImageNotSupportedOutlinedIcon />
        </Box>
      )}
    </Box>
  );
};
